<div class="modal-acknowledgments">
  <div class="modal-body">
    <div class="title">
      <h1>{{ 'acknowledgmentsHeader' | translate }}</h1>
      <div class="separator"></div>
    </div>
    <p>
        {{ 'acknowledgmentsText' | translate }}
    </p>
  </div>
  <div class="survey-buttons">
    <button type="button" class="btn btn-secondary" (click)="close()">
      Cerrar
    </button>
  </div>
</div>
